var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLlmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_993_61801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5352 19.8413H13.4102V17.9663H15.2852V19.8413H17.1602V12.3413H11.5352V19.8413ZM15.2852 14.2163V16.0913H13.4102V14.2163H15.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0352 12.3413H20.9102V19.8413H19.0352V12.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4879 8.77253C21.5413 6.84015 18.9642 5.77884 16.2234 5.77884C16.1976 5.77884 16.1716 5.7789 16.1457 5.77909C10.4891 5.82053 5.89743 10.4572 5.91018 16.1152C5.91743 19.3356 7.3885 22.3092 9.94606 24.2736C10.9559 25.0492 11.5352 26.2128 11.5352 27.4662V32.1538H20.9102V27.4663C20.9102 26.2137 21.4908 25.0489 22.5032 24.2706C25.0656 22.3007 26.5352 19.3193 26.5352 16.0913C26.5352 13.3225 25.453 10.7233 23.4879 8.77253ZM13.4102 30.2788V28.4038H19.0352V30.2788H13.4102ZM21.3604 22.7841C20.1376 23.7242 19.3468 25.0552 19.1103 26.5288H13.3353C13.0992 25.0548 12.3096 23.7246 11.0882 22.7865C8.99506 21.1789 7.79118 18.7458 7.78518 16.1108C7.77475 11.4817 11.5314 7.68784 16.1594 7.65403C16.1807 7.65384 16.2017 7.65378 16.223 7.65378C18.4656 7.65378 20.5744 8.52228 22.1669 10.1031C23.7747 11.6993 24.6602 13.826 24.6602 16.0913C24.6602 18.7325 23.4574 21.1718 21.3604 22.7841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2852 0.153839H17.1602V3.90384H15.2852V0.153839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25879 1.7229L10.9913 1.00478L12.4275 4.46978L10.695 5.1879L9.25879 1.7229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28906 5.48483L5.61469 4.15921L8.26594 6.81046L6.94031 8.13608L4.28906 5.48483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1416 10.861L1.85973 9.12854L5.32473 10.5648L4.6066 12.2973L1.1416 10.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.285156 15.1538H4.03516V17.0288H0.285156V15.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14648 21.3263L4.61148 19.89L5.32961 21.6225L1.86461 23.0588L1.14648 21.3263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28711 26.6957L6.93836 24.0445L8.26398 25.3701L5.61273 28.0213L4.28711 26.6957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1719 25.3722L25.4975 24.0466L28.1487 26.6978L26.8231 28.0235L24.1719 25.3722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1348 21.6242L27.8529 19.8917L31.3179 21.328L30.5998 23.0605L27.1348 21.6242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4102 15.1538H32.1602V17.0288H28.4102V15.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1299 10.5538L30.5949 9.11755L31.313 10.8501L27.848 12.2863L27.1299 10.5538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1748 6.81259L26.8261 4.16134L28.1517 5.48697L25.5004 8.13822L24.1748 6.81259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0273 4.47113L21.4636 1.00613L23.1961 1.72426L21.7598 5.18926L20.0273 4.47113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_61801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.222656 0.153839)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlmIcon);
export default __webpack_public_path__ + "static/media/llmIcon.75125be6e0abbae463c337fdf6ae32ab.svg";
export { ForwardRef as ReactComponent };